import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { styled } from 'styletron-react';
import { staticColors } from '../../../../const/colors/staticColors';
import { sizes } from '../../../../const/sizes';
export const RadioIconIndicator = styled(RadixRadioGroup.Indicator, (p) => ({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    outlineWidth: sizes.radio.borderWidth,
    outlineColor: staticColors.radioChecked,
    outlineStyle: 'solid',
    backgroundColor: p.$isDisabled
        ? staticColors.radioDisabled
        : staticColors.radioChecked,
}));
